// Home's berry cooling line (F16 UF-10), pulled out of Dashboard so its four
// honest states are testable: nothing to act on (no pill), loading, couldn't
// load, and a real count. A pending or failed read is a dash, never a 0.
import { Snowflake } from 'lucide-react'
import type { ReadState } from '@/lib/readState'
import type { CoolingSummary } from '@/hooks/useCoolingLane'
import { AlertPill } from './DashboardTiles'

/** Batches actually on the force-cooling line: everything but RELEASED, which
 *  has left it and only stays in the read so the wall board can show it. */
export function activeCoolingBatches(c: CoolingSummary): number {
  return c.total - (c.byStage.RELEASED ?? 0)
}

export function CoolingPill({ read, summary, onClick }: {
  read: ReadState
  summary: CoolingSummary
  /** Omitted when the viewer cannot open Force-Cooling: the pill is text. */
  onClick?: () => void
}) {
  if (read === 'usable') {
    const active = activeCoolingBatches(summary)
    // Same rule as every other Home pill: only when there is something to act on.
    if (active <= 0) return null
    return (
      <AlertPill
        icon={Snowflake}
        count={active}
        label={`batches force-cooling · ${summary.byStage.COOLING ?? 0} cooling · ${summary.byStage.IN_HOLDING ?? 0} holding · ${summary.overSla} over SLA`}
        tone={summary.overSla > 0 ? 'red' : 'sky'}
        onClick={onClick}
      />
    )
  }
  return (
    <AlertPill
      icon={Snowflake}
      count="—"
      label={`batches force-cooling · ${read === 'unread' ? 'couldn’t load' : 'loading'}`}
      tone="sky"
      onClick={onClick}
    />
  )
}
